import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
} from "antd";
import { Bar } from "react-chartjs-2";
import { EyeOutlined,ExportOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
//import { useHistory, useLocation } from "react-router-dom";
import { useInjectReducer, useInjectSaga } from "redux-injectors";

import { reducer, sliceKey, actions } from "./slice";
import { commodityAnalyticsSummarySaga } from "./saga";
import {
  selectSummaryData,
  selectLoading,
  selectTotalCommodities,
  selectAvgCompletion,
} from "./selectors";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title as ChartTitle,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ChartTitle,
  ChartTooltip,
  Legend,
  {
  id: "persistentLabels",
  afterDatasetsDraw(chart) {
    const { ctx, chartArea } = chart;
    const dataset = chart.data.datasets[0];
    const meta = chart.getDatasetMeta(0);

    ctx.save();
    ctx.fillStyle = "#000";
    ctx.font = "12px sans-serif";
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";

    const padding = 6;

    meta.data.forEach((bar, index) => {
      const value = dataset.data[index];
      const label = `${value}`;
      const labelWidth = ctx.measureText(label).width;

      let xPos = bar.x + padding;

      // If label goes beyond chart area, adjust position
      if (xPos + labelWidth > chartArea.right - 4) {
        xPos = bar.x - labelWidth - padding;
        ctx.textAlign = "right";
      } else {
        ctx.textAlign = "left";
      }

      ctx.fillText(label, xPos, bar.y);
    });

    ctx.restore();
  }
}
);

const { Text, Title } = Typography;
const { TabPane } = Tabs;

const CommodityAnalyticsSummary = ({
  filters = {},
  onDetailedClick = () => {},
}) => {
  const dispatch = useDispatch();
  // const history = useHistory();
  // const location = useLocation();

  // // Handle detailed view navigation
  // const handleDetailedClick = () => {
  //   if (onDetailedClick && typeof onDetailedClick === 'function') {
  //     onDetailedClick();
  //   } else {
  //     // Default navigation to detailed view with filters
  //     history.push("/bo/commoditysamplingdetailed", { filters });
  //   }
  // };

  const [viewType, setViewType] = useState("top");

  useInjectReducer({ key: sliceKey, reducer });
  useInjectSaga({ key: sliceKey, saga: commodityAnalyticsSummarySaga });

  const data = useSelector(selectSummaryData);
  const loading = useSelector(selectLoading);
  const total = useSelector(selectTotalCommodities);
  const avgCompletion = useSelector(selectAvgCompletion);

  // Create filterString once to avoid recreating on each render
  const filterString = JSON.stringify(filters);

  const sortedData = [...data]
    .sort((a, b) =>
   viewType === "top"
     ? b.sampleCollected - a.sampleCollected // Desc for Top
      : a.sampleCollected - b.sampleCollected // Asc for Bottom
  )


  const chartData = {
    labels: sortedData.map((item) => item.commodityName),
    datasets: [
      {
        label: "Sample Count",
        data: sortedData.map((item) => item.sampleCollected),
        backgroundColor: "#0D9488",
      },
    ],
  };

 const chartOptions = {
  indexAxis: "y",
  responsive: true,
  animation: false, // disables animation to ensure consistent rendering
  plugins: {
    legend: { display: false },
    tooltip: { enabled: true },
    persistentLabels: {}, // custom plugin we define above
  },
  scales: {
    x: {
      beginAtZero: true,
      ticks: { stepSize: 1 },
    },
  },
};



  // Fixed useEffect with proper dependencies
  useEffect(() => {
    dispatch(
      actions.fetchSummary({
        filtersString: filterString,
        view: viewType,
      })
    );
  }, [dispatch, filterString, viewType]);

  return (
    <Card
      title={
  <span style={{ color: "#fff", fontWeight: 500 }}>
    <EyeOutlined style={{ marginRight: 8, color: "#fff" }} />
    Commodity Sampling Analytics
  </span>
}
extra={
  <Button
    onClick={onDetailedClick}
    icon={<ExportOutlined style={{ color: "#fff" }} />}
    style={{
      backgroundColor: "#ea580c",
      border: "1px solid #fff",
      color: "#fff",
    }}
  >
    Detailed View
  </Button>
}

      headStyle={{ backgroundColor: "#ea580c" }}
      style={{ marginTop: 24 }}
    >
      <Tabs activeKey={viewType} onChange={setViewType}>
        {["top", "bottom"].map((type) => (
          <TabPane
            tab={`${type[0].toUpperCase() + type.slice(1)} 10`}
            key={type}
          >
            {loading ? (
              <Spin />
            ) : (
              <>
                <div style={{ marginBottom: 24 }}>
                  <Bar data={chartData} options={chartOptions} height={300} />
                </div>

                <Row gutter={16}>
                  <Col span={12}>
                    <Card style={{ backgroundColor: "#FFF7ED" }}>
                      <Text>Commodity Count</Text>
                      <Title style={{ color: "#EA580C", margin: 0 }}>{total}</Title>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card style={{ backgroundColor: "#ECFDF5" }}>
                      <Text>Avg Completion</Text>
                      <Title style={{ color: "#059669", margin: 0 }}>
                        {(avgCompletion ).toFixed(1)}%
                      </Title>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </TabPane>
        ))}
      </Tabs>
    </Card>
  );
};

export default CommodityAnalyticsSummary;